import { get, put, post, del } from 'redux/shelf/api';
import { createReducer } from 'redux/shelf/reducer';

export const actions = {
  getMetafields: get`shopify-metafields`(),
  createMetafield: post`shopify-metafields`(),
  updateMetafield: put`shopify-metafields/:id`(),
  deleteMetafield: del`shopify-metafields/:id`(),
};

export const reducer = createReducer(actions, {
  [`${actions.getMetafields}`]: (state, { payload: { entities } }) => ({
    ...state,
    entities,
  }),
  [`${actions.createMetafield}`]: (state, { payload: { entity } }) => ({
    ...state,
    entities: [...state.entities, entity],
  }),
  [`${actions.updateMetafield}`]: (state, { meta }) => ({
    ...state,
    entities: state.entities?.map((metafield) =>
      metafield.id === meta.id ? meta : metafield
    ),
  }),
  [`${actions.deleteMetafield}`]: (state, { meta }) => ({
    ...state,
    entities: state.entities?.filter((metafield) => metafield.id !== meta.id),
  }),
});
